// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { CheckCircleIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
// import FormInput from "../../../shared/components/ui/form/FormInput";
// import LeftAuth from "../components/leftAuth";
// import { useFormValidation, validationRules } from "../../../shared/hooks/useFormValidation";

// const ForgotPassword = () => {
//   // Hook Initializations
//   const navigate = useNavigate();
//   const [step, setStep] = useState("forgot");
//   const [isLoading, setIsLoading] = useState(false);
//   const [userList, setUserList] = useState([]);

//   // ✅ Use custom validation hook
//   const { values, errors, handleChange, handleBlur, validate } = useFormValidation({ email: "" }, { email: validationRules.email });

//   // Load mock data (optional / demo)
//   useEffect(() => {
//     const loadUsers = async () => {
//       try {
//         const response = await fetch("/data/forgotPassword.json");
//         const data = await response.json();
//         setUserList(data);
//       } catch (err) {
//         console.error("Error loading forgot password data:", err);
//       }
//     };
//     loadUsers();
//   }, []);

//   // Forgot Password Submit
//   const handleForgotSubmit = (e) => {
//     e.preventDefault();
//     if (!validate()) return; // ✅ Validate before submit

//     const userExists = userList.find((user) => user.email.toLowerCase() === values.email.toLowerCase());

//     if (!userExists) {
//       alert("No account found with this email address");
//       return;
//     }

//     setIsLoading(true);
//     setTimeout(() => {
//       setStep("sent");
//       setIsLoading(false);
//     }, 1500);
//   };

//   // Resend Email
//   const handleResendEmail = () => {
//     setIsLoading(true);
//     setTimeout(() => {
//       setIsLoading(false);
//       alert("Reset email resent successfully!");
//     }, 1500);
//   };

//   // Demo: Copy reset link
//   const simulateResetLink = () => {
//     const resetUrl = `${window.location.origin}/reset-password?token=demo-token&email=${encodeURIComponent(values.email)}`;
//     navigator.clipboard.writeText(resetUrl);
//     alert(`Demo reset link copied:\n${resetUrl}`);
//   };

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-2  grow bg-[#F7F7F8] flex justify-center items-center">
//       <LeftAuth />

//       <div className="h-auto lg:h-screen overflow-y-auto flex justify-center items-start py-0 lg:py-10 pb-3 lg:pb-0">
//         <div className="max-w-[390px] w-full px-5">
//           {step === "sent" ? (
//             // ✅ Email Sent Step
//             <div className="bg-white rounded-xl shadow-lg p-8 space-y-6 text-center">
//               <div className="mx-auto h-16 w-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
//                 <CheckCircleIcon className="h-8 w-8 text-green-600" />
//               </div>
//               <h2 className="text-3xl font-bold text-gray-900 mb-2">Check Your Email</h2>
//               <p className="text-gray-600">We’ve sent a password reset link to:</p>
//               <p className="text-blue-600 font-medium mb-6">{values.email}</p>

//               <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-left text-sm text-blue-700 space-y-1">
//                 <p className="font-medium text-blue-800">Next Steps:</p>
//                 <ul className="list-disc list-inside">
//                   <li>Check your email inbox</li>
//                   <li>Look for an email from VaxAdmin</li>
//                   <li>Click the reset link</li>
//                   <li>Create a new password</li>
//                 </ul>
//               </div>

//               <div className="flex gap-3">
//                 <button onClick={handleResendEmail} disabled={isLoading} className="flex-1 py-3 common-gradiant text-white rounded-xl font-semibold">
//                   {isLoading ? "Sending..." : "Resend Email"}
//                 </button>
//                 <button onClick={simulateResetLink} className="flex-1 py-3 bg-gray-600 text-white rounded-xl font-semibold">
//                   Copy Demo Link
//                 </button>
//               </div>

//               <button onClick={() => navigate("/login")} className="w-full flex items-center justify-center space-x-2 text-gray-600 hover:text-gray-800 mt-4">
//                 <ArrowLeftIcon className="h-4 w-4" />
//                 <span>Back to login</span>
//               </button>
//             </div>
//           ) : (
//             // ✅ Forgot Password Form
//             <form className="flex flex-col gap-5" onSubmit={handleForgotSubmit}>
//               <div className="text-center mb-2.5">
//                 <h3 className="text-4xl font-bold text-[#232526] mb-2.5">Forgot Password?</h3>
//                 <p className="font-normal mt-5 text-[#232526]">Don’t worry! Enter your email and we’ll send you a reset link.</p>
//               </div>

//               <FormInput label="Email Address" name="email" type="email" value={values.email} onChange={handleChange} onBlur={handleBlur} error={errors.email} placeholder="Enter your registered email" required />

//               <button type="submit" disabled={isLoading} className="py-3 common-gradiant text-white rounded-xl font-semibold">
//                 {isLoading ? (
//                   <div className="flex items-center justify-center">
//                     <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
//                     Sending Reset Link...
//                   </div>
//                 ) : (
//                   "Send Reset Link"
//                 )}
//               </button>

//               <button type="button" onClick={() => navigate("/login")} className="w-full flex items-center justify-center space-x-2 text-gray-600 hover:text-gray-800">
//                 <ArrowLeftIcon className="h-4 w-4" />
//                 <span>Back to login</span>
//               </button>

//               <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-sm text-yellow-800">
//                 <strong>Demo Mode:</strong> This is a demo — in production, a real email would be sent.
//               </div>
//             </form>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { CheckCircleIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import FormInput from "../../../shared/components/ui/form/FormInput";
import LeftAuth from "../components/leftAuth";
import { useFormValidation, validationRules } from "../../../shared/hooks/useFormValidation";
import { useAuth } from "../../../shared/hooks/useAuth";
import { setLoading } from "../../../app/store/slices/authSlice";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [step, setStep] = useState("forgot");
  const [isLoading, setIsLoading] = useState(false);
  const { forgotPassword, error, setError } = useAuth();

  const { values, errors, handleChange, handleBlur, validate } = useFormValidation({ email: "" }, { email: validationRules.email });

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!validate()) return;

    setIsLoading(true);

    try {
      const result = await forgotPassword(values.email);
      if (result) {
        setStep("sent");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendEmail = async () => {
    setIsLoading(true);
    try {
      const result = await forgotPassword(values.email);
      if (result) {
        alert("Reset email has been resent.");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 grow bg-[#F7F7F8] flex justify-center items-center">
      <LeftAuth />

      <div className="max-w-[390px] w-full mx-auto mt-10">
        {step === "sent" ? (
          <div className="text-center">
            <h3 className="text-4xl font-bold text-[#232526] leading-none mb-2.5">Check Your Email</h3>

            <div className="flex flex-col items-center mb-5">
              <p className="font-normal mt-5 text-[#232526]">We have sent a password reset link to:</p>
              <a href="#" className="text-blue-600 font-medium ">
                {values.email}
              </a>
            </div>

            <button onClick={handleResendEmail} disabled={isLoading} className="w-full py-3 common-gradiant text-white rounded-xl font-semibold">
              {isLoading ? "Resending..." : "Resend Email"}
            </button>

            {!isLoading && (
              <button
                onClick={() => {
                  dispatch(setLoading(false));
                  navigate("/login");
                }}
                className="w-full flex justify-center items-center text-gray-600 hover:text-gray-800 mt-4"
              >
                <ArrowLeftIcon className="h-4 w-4 mr-2" /> Back to login
              </button>
            )}
          </div>
        ) : (
          <form className="flex flex-col gap-5" onSubmit={handleForgotSubmit}>
            <div className="text-center">
              <h3 className="text-4xl font-bold">Forgot Password?</h3>
              <p className="text-gray-600 mt-3">Enter your email and we’ll send a password reset link.</p>
            </div>

            <FormInput label="Email Address" name="email" type="email" value={values.email} onChange={handleChange} onBlur={handleBlur} error={errors.email} placeholder="Enter your email" required />

            {error && <p className="text-red-500 text-center text-sm">{error}</p>}

            <button type="submit" disabled={isLoading} className="py-3 common-gradiant text-white rounded-xl font-semibold">
              {isLoading ? "Sending..." : "Send Reset Link"}
            </button>

            {!isLoading && (
              <button
                type="button"
                onClick={() => {
                  dispatch(setLoading(false));
                  navigate("/login");
                }}
                className="w-full flex justify-center items-center text-gray-600 hover:text-gray-800"
              >
                <ArrowLeftIcon className="h-4 w-4 mr-2" /> Back to login
              </button>
            )}
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
